export const nameTranslationsFr: Record<string, string> = {
  'Agar Agar': 'Agar-Agar',
  "Adenosine 5' Monophosphate": "Adénosine 5' Monophosphate",
  'Pectin': 'Pectine',
  'Iodine': 'Iode',
  'Guar Gum': 'Gomme de Guar',
  'Xanthan Gum': 'Gomme Xanthane',
  'Peppermint Oil': 'Huile de Menthe Poivrée',
  'Menthol Crystals': 'Cristaux de Menthol',
  'Chlorocresol': 'Chlorocrésol',
  'Calcium Sennosides': 'Sennosides de Calcium',
  'Citrated Caffeine': 'Caféine Citrée',
  'Para Chloro Benzyl Chloride': 'Chlorure de Para-Chlorobenzyle',
  'Dichloroacetate Sodium': 'Dichloroacétate de Sodium',
  'Diclofenac Sodium': 'Diclofénac Sodique',
  'Mefenamic Acid': 'Acide Méfénamique',
  'Cyanocobalamin': 'Cyanocobalamine',
  'Effervescent Tablet Manufacturing Access': 'Accès à la Fabrication de Comprimés Effervescents',
  'Fischer Tropsch Wax': 'Cire Fischer Tropsch',
};

export const categoryTranslationsFr: Record<string, string> = {
  'All': 'Tous',
  'Hydrocolloids & Gums': 'Hydrocolloïdes & Gommes',
  'Active Pharmaceutical Ingredients': 'Principes Actifs Pharmaceutiques',
  'Essential Oils & Flavours': 'Huiles Essentielles & Arômes',
  'Preservatives & Antimicrobials': 'Conservateurs & Antimicrobiens',
  'Nucleotides & Biochemicals': 'Nucléotides & Biochimiques',
  'Waxes & Lipids': 'Cires & Lipides',
  'Inorganic Chemicals': 'Produits Chimiques Inorganiques',
  'Fine Chemicals & Intermediates': 'Produits Chimiques Fins & Intermédiaires',
  'Manufacturing & Facility Access': 'Accès à la Fabrication',
};

export const productTranslationsFr: Record<string, {
  description: string;
  applications: string[];
}> = {
  'agar-agar': {
    description:
      'Polysaccharide naturel extrait d\'algues rouges, largement utilisé comme agent gélifiant dans les applications alimentaires, pharmaceutiques et microbiologiques. Conforme aux spécifications du Food Chemicals Codex (FCC).',
    applications: ['Milieux de culture microbiologique', 'Agent gélifiant alimentaire', 'Excipient pharmaceutique'],
  },
  'adenosine-5-monophosphate': {
    description:
      'Nucléotide monophosphate utilisé dans la recherche biochimique, les compléments nutritionnels et les formulations pharmaceutiques. Fourni selon notre standard qualité interne.',
    applications: ['Compléments nutritionnels', 'Recherche biochimique', 'IPA pharmaceutiques'],
  },
  'guar-gum': {
    description:
      'Polysaccharide galactomannane naturel disponible en plusieurs grades et viscosités. Utilisé comme épaississant, liant et stabilisant dans les applications pharmaceutiques, alimentaires et industrielles.',
    applications: ['Liant pour comprimés', 'Épaississant alimentaire', 'Applications industrielles'],
  },
  'peppermint-oil': {
    description:
      'Huile de menthe poivrée de haute pureté conforme aux spécifications de la Pharmacopée américaine (USP). Utilisée comme aromatisant, carminatif et analgésique topique dans les produits pharmaceutiques et de santé grand public.',
    applications: ['Produits de soins bucco-dentaires', 'Analgésiques topiques', 'Aromatisant pharmaceutique'],
  },
  'menthol-crystals': {
    description:
      'Cristaux de menthol d\'origine naturelle de grade pharmaceutique USP. Largement utilisés pour leur sensation de fraîcheur dans les formulations topiques, les soins bucco-dentaires et les produits respiratoires.',
    applications: ['Formulations topiques', 'Produits contre la toux et le rhume', 'Soins bucco-dentaires'],
  },
  'chlorocresol': {
    description:
      'Conservateur antimicrobien à large spectre conforme aux normes USP, Pharmacopée européenne (EP) et Pharmacopée britannique (BP). Utilisé dans les préparations pharmaceutiques injectables et topiques.',
    applications: ['Conservateur pour injectables', 'Préparations topiques', 'Formulations antiseptiques'],
  },
  'calcium-sennosides': {
    description:
      'Principe actif laxatif naturel extrait des feuilles de séné, disponible en concentrations de 20 %, 60 % et 90 % selon la spécification USP. Utilisé dans les formulations laxatives OTC et sur ordonnance.',
    applications: ['Formulations laxatives', 'Santé digestive OTC', 'Produits sur ordonnance'],
  },
  'citrated-caffeine': {
    description:
      'Caféine citrée de grade pharmaceutique conforme aux spécifications USP. Utilisée comme stimulant du système nerveux central et dans les formulations pour le traitement de l\'apnée néonatale.',
    applications: ['Traitement de l\'apnée néonatale', 'Formulations stimulantes du SNC', 'Associations analgésiques'],
  },
  'fischer-tropsch-wax': {
    description:
      'Cire dure synthétique produite par le procédé Fischer-Tropsch, disponible en grades FT 110 et FT 115. Utilisée comme agent d\'enrobage, modificateur de libération et lubrifiant dans les applications pharmaceutiques et industrielles.',
    applications: ['Enrobage de comprimés', 'Libération contrôlée', 'Lubrifiants industriels'],
  },
  'iodine': {
    description:
      'Iode de grade pharmaceutique conforme aux spécifications USP. Utilisé comme antiseptique, dans les médicaments thyroïdiens et comme réactif dans diverses applications pharmaceutiques et diagnostiques.',
    applications: ['Préparations antiseptiques', 'Médicaments thyroïdiens', 'Réactifs diagnostiques'],
  },
  'pectin': {
    description:
      'Polysaccharide naturel extrait de sources de pomme et d\'agrumes, disponible en plusieurs types et grades. Utilisé comme agent gélifiant, épaississant et stabilisant dans les applications alimentaires et pharmaceutiques.',
    applications: ['Agent gélifiant', 'Matrices de libération de médicaments', 'Stabilisant alimentaire'],
  },
  'para-chloro-benzyl-chloride': {
    description:
      'Intermédiaire chimique fin fourni selon notre standard qualité interne. Utilisé comme bloc de construction dans la synthèse de principes actifs pharmaceutiques et de produits chimiques spéciaux.',
    applications: ['Synthèse pharmaceutique', 'Intermédiaires chimiques', 'Produits chimiques spéciaux'],
  },
  'xanthan-gum': {
    description:
      'Polysaccharide de haute masse moléculaire produit par fermentation, conforme aux spécifications USP. Utilisé comme modificateur de viscosité, agent de suspension et stabilisant dans les formulations pharmaceutiques et alimentaires.',
    applications: ['Agent de suspension', 'Modificateur de viscosité', 'Stabilisant alimentaire'],
  },
  'cyanocobalamin': {
    description:
      'Cyanocobalamine (Vitamine B12) de grade pharmaceutique conforme aux spécifications USP, Pharmacopée européenne (EP) et Pharmacopée britannique (BP). Vitamine hydrosoluble essentielle utilisée dans le traitement et la prévention de la carence en vitamine B12, de l\'anémie pernicieuse et des troubles neurologiques. Disponible en plusieurs concentrations pour les applications orales, injectables et nutraceutiques.',
    applications: ['Formulations injectables de B12', 'Compléments vitaminiques oraux', 'Mélanges nutraceutiques', 'Traitement de l\'anémie pernicieuse', 'Formulations de soutien neurologique'],
  },
  'effervescent-tablet-manufacturing': {
    description:
      'Accès à une installation de fabrication certifiée qualité spécialisée dans la production de comprimés effervescents de toutes sortes — formats pharmaceutiques, nutraceutiques, compléments alimentaires et vétérinaires. L\'installation fonctionne selon les BPF avec des systèmes de gestion de la qualité complets, offrant des tailles de lots flexibles, le développement de formulations personnalisées et la production sous marque privée.',
    applications: [
      'Effervescents pharmaceutiques OTC',
      'Comprimés nutraceutiques et vitaminés',
      'Nutrition sportive et électrolytes',
      'Produits effervescents vétérinaires',
      'Fabrication sous contrat marque privée',
      'Développement de formulations personnalisées',
    ],
  },
  'diclofenac-sodium': {
    description:
      'Principe actif anti-inflammatoire non stéroïdien (AINS) conforme aux spécifications USP, Pharmacopée européenne (EP) et Pharmacopée britannique (BP). Largement utilisé dans le traitement de la douleur, de l\'inflammation et de l\'arthrite sous formes orales, topiques et injectables.',
    applications: ['Comprimés analgésiques et anti-inflammatoires oraux', 'Gels et crèmes topiques', 'Formulations injectables', 'Préparations ophtalmiques'],
  },
  'dichloroacetate-sodium': {
    description:
      'Dichloroacétate de sodium fourni selon notre standard qualité interne. Composé de petite molécule utilisé dans la recherche et les applications pharmaceutiques, notamment étudié pour son rôle dans la modulation métabolique et la fonction mitochondriale.',
    applications: ['Recherche pharmaceutique', 'Études sur les troubles métaboliques', 'Formulations médicamenteuses expérimentales'],
  },
  'mefenamic-acid': {
    description:
      'Principe actif anti-inflammatoire non stéroïdien (AINS) conforme aux spécifications USP, Pharmacopée européenne (EP) et Pharmacopée britannique (BP). Utilisé principalement pour le traitement à court terme des douleurs légères à modérées et de la dysménorrhée sous formes orales.',
    applications: ['Gélules et comprimés analgésiques oraux', 'Traitement de la dysménorrhée', 'Formulations anti-inflammatoires'],
  },
};
